export function maxLengthCheck(object){
  if (object.value > 100)
  {
    object.value = object.value.slice(0, object.maxLength)
  }
}